import { render, staticRenderFns } from "./NoNotifications.vue?vue&type=template&id=529d070f"
import script from "./NoNotifications.vue?vue&type=script&lang=js"
export * from "./NoNotifications.vue?vue&type=script&lang=js"
import style0 from "./NoNotifications.vue?vue&type=style&index=0&id=529d070f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports